<template>
  <div id="event-live-eventer-message-list">
    <template v-for="(comment, index) in comments">
      <template v-if="comment.is_fix_top">
        <div class="event-live-eventer-message-list--section--fix_ping">
          <div class="event-live-eventer-message-list--section--row_buttons_dummy"></div>
          <img v-bind:src="require('assets/images/ping_icon_gray.png')" class="event-live-eventer-message-list--section--fix_ping--icon_ping">
          <p class="event-live-eventer-message-list--section--fix_ping--label">&nbsp;固定されたコメント</p>
        </div>
      </template>
      <div class="event-live-eventer-message-list--section--form">
        <template v-if="comment.avatar != 'undefined' && comment.avatar != '' ">
          <img v-bind:src="comment.avatar" class="event-live-eventer-message-list--image__circle">
        </template>
        <template v-else>
          <img v-bind:src="require('assets/images/person_shadow_gray')" class="event-live-eventer-message-list--image__circle">
        </template>
        <div class="event-live-eventer-message-list--section--row_label_wrap">
          <div class="event-live-eventer-message-list--section--row_label">
            <p class="event-live-eventer-message-list--label__black__little">{{comment.uName}}</p>
            <p class="event-live-eventer-message-list--label__gray__little">{{formatDate(comment.createdAt)}}</p>
          </div>
          <div class="event-live-eventer-message-list--section--row_body">
            <template v-if="comment.do_edit && isorganizer">
              <textarea name="body" class="event-live-eventer-message-list--label__gray event-live-eventer-message-list--textarea__edit_message" maxlength="1000" :rows="setTextareaRows(comment.body)" :class="'editable_' +comment.id" v-model="comment.body"></textarea>
            </template>
            <template v-else>
              <div class="event-live-eventer-message-list--label__gray" :class="'non_editable_' + comment.id" v-html="replaceUrl(comment.body)"></div>
            </template>
          </div>
        </div>
      </div>
      <template v-if="isorganizer">
        <div class="event-live-eventer-message-list--section--row_buttons">
          <div class="event-live-eventer-message-list--section--row_buttons_dummy"></div>
          <template v-if="comment.do_edit">
            <div class="event-live-eventer-message-list--section-mod_message">
              <div class="event-live-eventer-message-list--line__gray"></div>
              <div class="event-live-eventer-message-list--section-button__blue" v-on:click="messageCommit(comment)">保存</div>
            </div>
          </template>
          <template v-else>
            <div class="event-live-eventer-message-list--section-button" v-on:click="messageEdit(comment)">編集</div>
            <div class="event-live-eventer-message-list--section-button" v-on:click="messageDelete(comment.id)">削除</div>
            <template v-if="comment.is_fix_top">
              <div class="event-live-eventer-message-list--section-button" v-on:click="messageSettingFix(comment.id, comment.is_fix_top)">トップ固定解除</div>
            </template>
            <template v-else>
              <div class="event-live-eventer-message-list--section-button" v-on:click="messageSettingFix(comment.id, comment.is_fix_top)">トップ固定</div>
            </template>
          </template>
        </div>
      </template>
      <template v-else>
        <div class="event-live-eventer-message-list--section--row_dummy"></div>
      </template>
    </template>
  </div>
</template>

<script>
  import {db} from '../utils/firebase'
  import firebase from "firebase/app"
  import consts from '../utils/consts'
  import axios from "axios";

  export default {
    name: "EventLiveEventerMessageList",
    props: {
      ttsid: { type: String, required: true },
      isorganizer: { type: Boolean, required: true },
    },
    data: () => ({
      comments:[],
      commentCnt: -1,
      isCompleteLoad: false,
    }),
    firestore() {
      const roomId = this.ttsid;
      const firstdoc = "start"
      // コメントの取得
      return {
        comments: db.collection(consts.EVENT_LIVE_EVENTER_COMMENT.PARENT_COLLECTION).doc(roomId).collection(consts.EVENT_LIVE_EVENTER_COMMENT.CHILD_COLLECTTION).orderBy('is_fix_top', 'desc').orderBy('createdAt', 'desc')
      }
    },
    computed: {
      consts: function() {
        return consts
      }
    },
    methods: {
      // 日付整形(yyyy/n/d hh:mm)
      formatDate: function(date) {
        if (date == 'undefined' || date == null || date.length > 0){
          return ""
        }
        var day = date.toDate()
        return day.getFullYear() + '/' + (day.getMonth() + 1).toString().padStart(2, '0') + '/' + day.getDate().toString().padStart(2, '0') + " " + day.getHours().toString().padStart(2, '0') + ":" + day.getMinutes().toString().padStart(2, '0')
      },
      // メッセージ削除
      messageDelete: function(docId) {
        if (!confirm("コメントを削除します。よろしいですか？")) {
          return false
        }
        db.collection(consts.EVENT_LIVE_EVENTER_COMMENT.PARENT_COLLECTION).doc(this.ttsid).collection(consts.EVENT_LIVE_EVENTER_COMMENT.CHILD_COLLECTTION).doc(docId).delete()
      },
      // メッセージ編集
      messageEdit: function(doc) {
        // 状態を編集状態にする
        const target = db.collection(consts.EVENT_LIVE_EVENTER_COMMENT.PARENT_COLLECTION).doc(this.ttsid).collection(consts.EVENT_LIVE_EVENTER_COMMENT.CHILD_COLLECTTION).doc(doc.id)
        target.update({
          do_edit: true,
          updatedAt: firebase.firestore.FieldValue.serverTimestamp(),
        })
      },
      // メッセージ更新
      messageCommit: function(doc) {
        // 更新する
        const afterStr = $('.editable_' + doc.id).val().trim()
        if (1 > afterStr.length) {
          this.messageDelete(doc.id)
          return
        }
        const target = db.collection(consts.EVENT_LIVE_EVENTER_COMMENT.PARENT_COLLECTION).doc(this.ttsid).collection(consts.EVENT_LIVE_EVENTER_COMMENT.CHILD_COLLECTTION).doc(doc.id)
        target.update({
          body: afterStr,
          do_edit: false,
          updatedAt: firebase.firestore.FieldValue.serverTimestamp(),
        })
      },
      // メッセージトップ固定
      messageSettingFix: function(docId, isFix) {
        (async () => {
          // 全体のトップ固定を解除
          await db.collection(consts.EVENT_LIVE_EVENTER_COMMENT.PARENT_COLLECTION).doc(this.ttsid).collection(consts.EVENT_LIVE_EVENTER_COMMENT.CHILD_COLLECTTION).where("is_fix_top", "==", true).get()
            .then(function(querySnapshot) {
              querySnapshot.forEach(function(doc) {
                doc.ref.update({
                  is_fix_top: false,
                  updatedAt: firebase.firestore.FieldValue.serverTimestamp(),
                })
              });
            })
          // トップ固定
          const target = await db.collection(consts.EVENT_LIVE_EVENTER_COMMENT.PARENT_COLLECTION).doc(this.ttsid).collection(consts.EVENT_LIVE_EVENTER_COMMENT.CHILD_COLLECTTION).doc(docId)
          target.update({
            is_fix_top: !isFix,
            updatedAt: firebase.firestore.FieldValue.serverTimestamp(),
          })
        })()
      },
      setTextareaRows: function(body) {
        var rows = (body.match( /\n/g ) || [] ).length + 1
        if (3 > rows){
          rows = 3
        }
        return rows
      },
      // URL文字列にaタグを付加
      replaceUrl: function(str){
        var text  = this.escape_html_tag(str).replace(/\r\n|\r/g, "\n");
        var lines = text.split( '\n' );
        var afterStr = "";
        for(var i = 0; i < lines.length; i++) {
          if (lines[i].indexOf('https:') > -1){
            var beforeLinkStr = lines[i].slice(lines[i].indexOf('https:'))
            var afterLinkStr = '<a href="' + beforeLinkStr + '" target="_blank">' + beforeLinkStr + '</a>'
            afterStr = afterStr + lines[i].replace(beforeLinkStr, afterLinkStr)
          } else {
            afterStr = afterStr + lines[i]
          }
          afterStr = afterStr + '\n'
        }
        return afterStr;
      },
      // エスケープ
      escape_html_tag: function(str){
        return str.replace(/[&'`"<>]/g, function(match) {
          return {
            '&': '&amp;',
            "'": '&#x27;',
            '`': '&#x60;',
            '"': '&quot;',
            '<': '&lt;',
            '>': '&gt;',
          }[match]
        });
      }
    },
    watch: {
      comments: function () {
        if (this.comments.length > this.commentCnt && this.isCompleteLoad) {
          this.$toasted.error("新着コメントがあります")
          $('.tooastedOption').css('background-color',"red")
        }
        setCustomStyle('#event-live-eventer-message-list')
        this.commentCnt = this.comments.length
      },
    },
    created(){
      setCustomStyle('#event-live-eventer-message-list')
    },
    mounted: function () {
      // onLoadイベント
      var _this = this
      window:onload = function() {
        _this.isCompleteLoad = true
      }
    },
  }
</script>

<style lang="scss" scoped>
  @import '../packs/application.css';

  #event-live-eventer-message-list {
    margin-bottom: 30px;
  }

  .event-live-eventer-message-list--section--fix_ping {
    display: flex;
    height: 10px;
    margin-bottom: 2px;

    .event-live-eventer-message-list--section--fix_ping--icon_ping {
      width: 10px;
      height: 10px;
    }

    .event-live-eventer-message-list--section--fix_ping--label {
      color: #999999;
      font-size: 12px;
      white-space: nowrap;
      margin-top: -4px;
    }
  }

  .event-live-eventer-message-list--section--form {
    display: flex;
  }

  .event-live-eventer-message-list--image__circle {
    border-radius: 50%;
    width: 50px;
    height: 50px;
    margin-right: 15px;
  }

  .event-live-eventer-message-list--section--row_label {
    display: flex;
  }

  .event-live-eventer-message-list--section--row_label_wrap{
    width: calc(100% - 60px);
  }

  .event-live-eventer-message-list--label__black__little {
    font-size: 12px;
    font-weight: 600;
    margin-bottom: 7px;

    @media (max-width: 450px) {
      max-width: 200px;
    }
  }

  .event-live-eventer-message-list--label__gray {
    font-size: 13px;
    width: 100%;
    overflow-wrap: break-word;
    margin-bottom: 10px;
    white-space: pre-wrap;
  }

  .event-live-eventer-message-list--textarea__edit_message {
    border: none;
    resize: vertical;
    background: #FAFAFA;

    @media screen and (max-width: 1000px) {
      font-size: 16px;
    }
  }

  .event-live-eventer-message-list--label__gray__little {
    color: #999999;
    font-size: 12px;
    margin-left: 15px;
    white-space: nowrap;
  }

  .event-live-eventer-message-list--section--row_buttons {
    display: flex;
    margin-bottom: 20px;
  }

  .event-live-eventer-message-list--section--row_buttons_dummy {
    width: 65px;
  }

  .event-live-eventer-message-list--section-button {
    color: #999999;
    font-size: 12px;
    margin-right: 15px;
    cursor: pointer;
  }

  .event-live-eventer-message-list--section-mod_message {
    width: 100%;
    margin-left: 5px;
  }

  .event-live-eventer-message-list--section-button__blue {
    @extend .event-live-eventer-message-list--section-button;

    color: #3399CC;
  }

  .event-live-eventer-message-list--line__gray {
    width: 100%;
    height: 1px;
    border-bottom: 1px solid #B3B4B3;
    margin: 12px 0;
  }

  .event-live-eventer-message-list--section--row_dummy {
    height: 20px;
  }

</style>
